import { render, staticRenderFns } from "./EditIncoterm.vue?vue&type=template&id=475caae6"
import script from "./EditIncoterm.vue?vue&type=script&lang=js"
export * from "./EditIncoterm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports